var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1),(!_vm.isLogin)?_c('div',{staticClass:"ba"},[_c('h6',[_vm._v("©2019-2022 All Right Reserved.阳光体育")])]):_vm._e(),(_vm.isLogin)?_c('main-tab-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}]}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }